import Axios from 'api/client';
import qs from 'qs';
import { Fund } from 'types/domain';
import { PaginatedData } from 'types/pagination';
import { FilterParams } from 'types/params';

interface ReorderFundsParams {
    order: number[];
}

interface CreateOrUpdateFundParams {
    name: string;
    code: string;
}

interface FetchFundsParams extends FilterParams {}

const fetchFunds = (accountId: number, params: FetchFundsParams = {}) => {
    const { filters, ...restParams } = params;
    const stringifiedFilters = filters ? qs.stringify(filters) : '';

    return Axios.get<PaginatedData<Fund>>(`/accounts/${accountId}/funds?${stringifiedFilters}`, {
        params: restParams,
    }).then(response => response.data);
};

const fetchFundById = (accountId: number, fundId: number) =>
    Axios.get<Fund>(`/accounts/${accountId}/funds/${fundId}`).then(response => response.data);

const reorderFunds = (accountId: number, { order }: ReorderFundsParams) =>
    Axios.patch(`/accounts/${accountId}/reorder-funds`, {
        order,
    }).then(response => response.data);

const deleteFund = (accountId: number, fundId: number) =>
    Axios.delete(`/accounts/${accountId}/funds/${fundId}`).then(response => response.data);

const createFund = (accountId: number, args: CreateOrUpdateFundParams) =>
    Axios.post<Fund>(`/accounts/${accountId}/funds`, args).then(response => response.data);

const updateFund = (accountId: number, fundId: number, args: CreateOrUpdateFundParams) =>
    Axios.patch<Fund>(`/accounts/${accountId}/funds/${fundId}`, args).then(
        response => response.data,
    );

export { fetchFunds, fetchFundById, reorderFunds, deleteFund, createFund, updateFund };
export type { FetchFundsParams };
